'use client';

import { createFaroAdapter } from '@/lib/analytics/adapters/faro';
import { createAnalyticsTracker } from '@/lib/analytics/tracker';

/**
 * The Faro adapter is exposed for symmetry. FaroProvider controls whether full
 * RUM is enabled, and the adapter methods emit only while that gate is active.
 * All other code should import `tracker` only.
 */
export const faroAdapter = createFaroAdapter();

/**
 * The central tracker. Fan-out composite that calls all adapters in order.
 *
 * To add a new platform: implement AnalyticsAdapter and add it here.
 */
export const tracker = createAnalyticsTracker([faroAdapter]);
